import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFollowUpEventsStatus } from "../../api/EmployeeFollowUpEventApi";
import FollowUpEventStatusListForm from "./FollowUpEventStatusListForm";
import "./ManageFollowUpEventStatusListPage.css";
import moment from "moment";
import { Month } from "../common/GeneralConfigurations";

function ManageFollowUpEventStatusListPage() {
  const { t } = useTranslation();
  const [followUpEventsStatusData, setFollowUpEventsStatusData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    moment([moment().year(), 0, 1]).format("MM-DD-yyyy")
  );
  const [endDate, setEndDate] = useState(
    moment([moment().year(), 11, 31]).format("MM-DD-yyyy")
  );

  useEffect(() => {
    onGetFollowUpEventStatus();
  }, [startDate, endDate]);

  const columns = [
    {
      title: t("followUpEventStatus.columns.name"),
      dataIndex: "staffName",
      key: "staffName",
      width: 150,
    },
    {
      title: t("followUpEventStatus.columns.firstYear"),
      children: [
        {
          title: t("followUpEventStatus.events.pds2MonthCall"),
          dataIndex: "year1Month2",
          key: "year1Month2",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month2Total !== undefined ? (
                <>
                  {record.year1Month2}/{record.year1Month2Total}
                </>
              ) : (
                <>{record.year1Month2}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.meeting4Month"),
          dataIndex: "year1Month4",
          key: "year1Month4",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month4Total !== undefined ? (
                <>
                  {record.year1Month4}/{record.year1Month4Total}
                </>
              ) : (
                <>{record.year1Month4}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.meeting6Month"),
          dataIndex: "year1Month6",
          key: "year1Month6",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month6Total !== undefined ? (
                <>
                  {record.year1Month6}/{record.year1Month6Total}
                </>
              ) : (
                <>{record.year1Month6}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.meeting9Month"),
          dataIndex: "year1Month9",
          key: "year1Month9",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month9Total !== undefined ? (
                <>
                  {record.year1Month9}/{record.year1Month9Total}
                </>
              ) : (
                <>{record.year1Month9}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.meeting12Month"),
          dataIndex: "year1Month12",
          key: "year1Month12",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.year1Month12Total !== undefined ? (
                <>
                  {record.year1Month12}/{record.year1Month12Total}
                </>
              ) : (
                <>{record.year1Month12}</>
              )}
            </>
          ),
        },
      ],
    },
    {
      title: t("followUpEventStatus.columns.nextYears"),
      children: [
        {
          title: t("followUpEventStatus.events.meeting3MonthNextYears"),
          dataIndex: "nextYearsMonth3",
          key: "nextYearsMonth3",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth3Total !== undefined ? (
                <>
                  {record.nextYearsMonth3}/{record.nextYearsMonth3Total}
                </>
              ) : (
                <>{record.nextYearsMonth3}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.pdsIntercalar6MonthNextYears"),
          dataIndex: "nextYearsMonth6",
          key: "nextYearsMonth6",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth6Total !== undefined ? (
                <>
                  {record.nextYearsMonth6}/{record.nextYearsMonth6Total}
                </>
              ) : (
                <>{record.nextYearsMonth6}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.pds9MonthCallNextYears"),
          dataIndex: "nextYearsMonth9",
          key: "nextYearsMonth9",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth9Total !== undefined ? (
                <>
                  {record.nextYearsMonth9}/{record.nextYearsMonth9Total}
                </>
              ) : (
                <>{record.nextYearsMonth9}</>
              )}
            </>
          ),
        },
        {
          title: t("followUpEventStatus.events.meeting12MonthNextYears"),
          dataIndex: "nextYearsMonth12",
          key: "nextYearsMonth12",
          className: "antd-col-title",
          align: "center",
          render: (text, record) => (
            <>
              {record.nextYearsMonth12Total !== undefined ? (
                <>
                  {record.nextYearsMonth12}/{record.nextYearsMonth12Total}
                </>
              ) : (
                <>{record.nextYearsMonth12}</>
              )}
            </>
          ),
        },
      ],
    },
    {
      title: t("followUpEventStatus.columns.academia"),
      dataIndex: "academic",
      key: "academic",
      align: "center",
      render: (text, record) => (
        <>
          {record.academicTotal !== undefined ? (
            <>
              {record.academic}/{record.academicTotal}
            </>
          ) : (
            <>{record.academic}</>
          )}
        </>
      ),
    },
    {
      title: t("followUpEventStatus.columns.monthlyPDS"),
      dataIndex: "monthlyPDS",
      key: "monthlyPDS",
      align: "center",
      render: (text, record) => (
        <>
          {record.monthlyPDSTotal !== undefined ? (
            <>
              {record.monthlyPDS}/{record.monthlyPDSTotal}
            </>
          ) : (
            <>{record.monthlyPDS}</>
          )}
        </>
      ),
    },
    {
      title: <strong>Total</strong>,
      dataIndex: "totalPerRow",
      key: "totalPerRow",
      align: "center",
      render: (text, record) => (
        <>
          {record.totalPerRowTotal !== undefined ? (
            <strong>
              {record.totalPerRow}/{record.totalPerRowTotal}
            </strong>
          ) : (
            <>{record.totalPerRow}</>
          )}
        </>
      ),
    },
  ];

  const onGetFollowUpEventStatus = async () => {
    await getFollowUpEventsStatus(startDate, endDate).then((res) => {
      let finalList = [];
      let final = 0;
      let year1Month2 = 0;
      let year1Month4 = 0;
      let year1Month6 = 0;
      let year1Month9 = 0;
      let year1Month12 = 0;
      let nextYearsMonth3 = 0;
      let nextYearsMonth6 = 0;
      let nextYearsMonth9 = 0;
      let nextYearsMonth12 = 0;
      let finalTotal = 0;
      let year1Month2Total = 0;
      let year1Month4Total = 0;
      let year1Month6Total = 0;
      let year1Month9Total = 0;
      let year1Month12Total = 0;
      let nextYearsMonth3Total = 0;
      let nextYearsMonth6Total = 0;
      let nextYearsMonth9Total = 0;
      let nextYearsMonth12Total = 0;
      let academic = 0;
      let academicTotal = 0;
      let monthlyPDS = 0;
      let monthlyPDSTotal = 0;

      res.data.map((x) => {
        if (x.doneById != null) {
          let found = finalList.find((e) => e.staffName === x.doneByName);
          let findIndex = finalList.findIndex(
            (e) => e.staffName === x.doneByName
          );

          if (found == undefined) {
            let newOne = {
              staffName: x.doneByName,
              year1Month2: 0,
              year1Month4: 0,
              year1Month6: 0,
              year1Month9: 0,
              year1Month12: 0,
              nextYearsMonth3: 0,
              nextYearsMonth6: 0,
              nextYearsMonth9: 0,
              nextYearsMonth12: 0,
              totalPerRow: 0,
              year1Month2Total: 0,
              year1Month4Total: 0,
              year1Month6Total: 0,
              year1Month9Total: 0,
              year1Month12Total: 0,
              nextYearsMonth3Total: 0,
              nextYearsMonth6Total: 0,
              nextYearsMonth9Total: 0,
              nextYearsMonth12Total: 0,
              totalPerRowTotal: 0,
              academic: 0,
              academicTotal: 0,
              monthlyPDS: 0,
              monthlyPDSTotal: 0,
            };

            if (x.eventTypeId >= 20 && x.eventTypeId <= 33) {
              newOne.monthlyPDS = x.countDone;
              monthlyPDS += newOne.monthlyPDS;
              newOne.monthlyPDSTotal = x.countDone + x.countUndone;
              monthlyPDSTotal += newOne.monthlyPDSTotal;
            }

            if (x.isFirstYear) {
              switch (x.month) {
                case Month.Zero:
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    newOne.academic = x.countDone;
                    academic += newOne.academic;
                    newOne.academicTotal = x.countDone + x.countUndone;
                    academicTotal += newOne.academicTotal;
                  }
                  break;
                case Month.Two:
                  newOne.year1Month2 = x.countDone;
                  year1Month2 += newOne.year1Month2;
                  newOne.year1Month2Total = x.countDone + x.countUndone;
                  year1Month2Total += newOne.year1Month2Total;
                  break;
                case Month.Three:
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    newOne.academic = x.countDone;
                    academic += newOne.academic;
                    newOne.academicTotal = x.countDone + x.countUndone;
                    academicTotal += newOne.academicTotal;
                  }
                  break;
                case Month.Four:
                  newOne.year1Month4 = x.countDone;
                  year1Month4 += newOne.year1Month4;
                  newOne.year1Month4Total = x.countDone + x.countUndone;
                  year1Month4Total += newOne.year1Month4Total;
                  break;
                case Month.Six:
                  if (x.eventTypeId == 6) {
                    newOne.year1Month6 = x.countDone;
                    year1Month6 += newOne.year1Month6;
                    newOne.year1Month6Total = x.countDone + x.countUndone;
                    year1Month6Total += newOne.year1Month6Total;
                  }
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    newOne.academic = x.countDone;
                    academic += newOne.academic;
                    newOne.academicTotal = x.countDone + x.countUndone;
                    academicTotal += newOne.academicTotal;
                  }
                  break;
                case Month.Nine:
                  if (x.eventTypeId == 7) {
                    newOne.year1Month9 = x.countDone;
                    year1Month9 += newOne.year1Month9;
                    newOne.year1Month9Total = x.countDone + x.countUndone;
                    year1Month9Total += newOne.year1Month9Total;
                  }
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    newOne.academic = x.countDone;
                    academic += newOne.academic;
                    newOne.academicTotal = x.countDone + x.countUndone;
                    academicTotal += newOne.academicTotal;
                  }
                  break;
                case Month.Twelve:
                  newOne.year1Month12 = x.countDone;
                  year1Month12 += newOne.year1Month12;
                  newOne.year1Month12Total = x.countDone + x.countUndone;
                  year1Month12Total += newOne.year1Month12Total;
                  break;
              }
            } else {
              switch (x.month) {
                case Month.Three:
                  newOne.nextYearsMonth3 = x.countDone;
                  nextYearsMonth3 += newOne.nextYearsMonth3;
                  newOne.nextYearsMonth3Total = x.countDone + x.countUndone;
                  nextYearsMonth3Total += newOne.nextYearsMonth3Total;
                  break;
                case Month.Six:
                  newOne.nextYearsMonth6 = x.countDone;
                  nextYearsMonth6 += newOne.nextYearsMonth6;
                  newOne.nextYearsMonth6Total = x.countDone + x.countUndone;
                  nextYearsMonth6Total += newOne.nextYearsMonth6Total;
                  break;
                case Month.Nine:
                  newOne.nextYearsMonth9 = x.countDone;
                  nextYearsMonth9 += newOne.nextYearsMonth9;
                  newOne.nextYearsMonth9Total = x.countDone + x.countUndone;
                  nextYearsMonth9Total += newOne.nextYearsMonth9Total;
                  break;
                case Month.Twelve:
                  newOne.nextYearsMonth12 = x.countDone;
                  nextYearsMonth12 += newOne.nextYearsMonth12;
                  newOne.nextYearsMonth12Total = x.countDone + x.countUndone;
                  nextYearsMonth12Total += newOne.nextYearsMonth12Total;
                  break;
              }
            }

            let totalPerRow = 0;
            totalPerRow =
              newOne.year1Month2 +
              newOne.year1Month4 +
              newOne.year1Month6 +
              newOne.year1Month9 +
              newOne.year1Month12 +
              newOne.nextYearsMonth3 +
              newOne.nextYearsMonth6 +
              newOne.nextYearsMonth9 +
              newOne.nextYearsMonth12;
            newOne.totalPerRow = totalPerRow;

            let totalPerRowTotal = 0;
            totalPerRowTotal =
              newOne.year1Month2Total +
              newOne.year1Month4Total +
              newOne.year1Month6Total +
              newOne.year1Month9Total +
              newOne.year1Month12Total +
              newOne.nextYearsMonth3Total +
              newOne.nextYearsMonth6Total +
              newOne.nextYearsMonth9Total +
              newOne.nextYearsMonth12Total;
            newOne.totalPerRowTotal = totalPerRowTotal;

            final =
              year1Month2 +
              year1Month4 +
              year1Month6 +
              year1Month9 +
              year1Month12 +
              nextYearsMonth3 +
              nextYearsMonth6 +
              nextYearsMonth9 +
              nextYearsMonth12;

            finalTotal =
              year1Month2Total +
              year1Month4Total +
              year1Month6Total +
              year1Month9Total +
              year1Month12Total +
              nextYearsMonth3Total +
              nextYearsMonth6Total +
              nextYearsMonth9Total +
              nextYearsMonth12Total;

            finalList.push(newOne);
          } else {
            if (x.eventTypeId >= 20 && x.eventTypeId <= 33) {
              finalList[findIndex].monthlyPDS += x.countDone;
              monthlyPDS += x.countDone;
              finalList[findIndex].monthlyPDSTotal +=
                x.countDone + x.countUndone;
              monthlyPDSTotal += x.countDone + x.countUndone;
            }

            if (x.isFirstYear) {
              switch (x.month) {
                case Month.Zero:
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    finalList[findIndex].academic += x.countDone;
                    academic += x.countDone;
                    finalList[findIndex].academicTotal +=
                      x.countDone + x.countUndone;
                    academicTotal += x.countDone + x.countUndone;
                  }
                  break;
                case Month.Two:
                  finalList[findIndex].year1Month2 += x.countDone;
                  year1Month2 += x.countDone;
                  finalList[findIndex].year1Month2Total +=
                    x.countDone + x.countUndone;
                  year1Month2Total += x.countDone + x.countUndone;
                  break;
                case Month.Three:
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    finalList[findIndex].academic += x.countDone;
                    academic += x.countDone;
                    finalList[findIndex].academicTotal +=
                      x.countDone + x.countUndone;
                    academicTotal += x.countDone + x.countUndone;
                  }
                  break;
                case Month.Four:
                  finalList[findIndex].year1Month4 += x.countDone;
                  year1Month4 += x.countDone;
                  finalList[findIndex].year1Month4Total +=
                    x.countDone + x.countUndone;
                  year1Month4Total += x.countDone + x.countUndone;
                  break;
                case Month.Six:
                  if (x.eventTypeId == 6) {
                    finalList[findIndex].year1Month6 += x.countDone;
                    year1Month6 += x.countDone;
                    finalList[findIndex].year1Month6Total +=
                      x.countDone + x.countUndone;
                    year1Month6Total += x.countDone + x.countUndone;
                  }
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    finalList[findIndex].academic += x.countDone;
                    academic += x.countDone;
                    finalList[findIndex].academicTotal +=
                      x.countDone + x.countUndone;
                    academicTotal += x.countDone + x.countUndone;
                  }
                  break;
                case Month.Nine:
                  if (x.eventTypeId == 7) {
                    finalList[findIndex].year1Month9 += x.countDone;
                    year1Month9 += x.countDone;
                    finalList[findIndex].year1Month9Total +=
                      x.countDone + x.countUndone;
                    year1Month9Total += x.countDone + x.countUndone;
                  }
                  if (x.eventTypeId >= 9 && x.eventTypeId <= 12) {
                    finalList[findIndex].academic += x.countDone;
                    academic += x.countDone;
                    finalList[findIndex].academicTotal +=
                      x.countDone + x.countUndone;
                    academicTotal += x.countDone + x.countUndone;
                  }
                  break;
                case Month.Twelve:
                  finalList[findIndex].year1Month12 += x.countDone;
                  year1Month12 += x.countDone;
                  finalList[findIndex].year1Month12Total +=
                    x.countDone + x.countUndone;
                  year1Month12Total += x.countDone + x.countUndone;
                  break;
              }
            } else {
              switch (x.month) {
                case Month.Three:
                  finalList[findIndex].nextYearsMonth3 += x.countDone;
                  nextYearsMonth3 += x.countDone;
                  finalList[findIndex].nextYearsMonth3Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth3Total += x.countDone + x.countUndone;
                  break;
                case Month.Six:
                  finalList[findIndex].nextYearsMonth6 += x.countDone;
                  nextYearsMonth6 += x.countDone;
                  finalList[findIndex].nextYearsMonth6Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth6Total += x.countDone + x.countUndone;
                  break;
                case Month.Nine:
                  finalList[findIndex].nextYearsMonth9 += x.countDone;
                  nextYearsMonth9 += x.countDone;
                  finalList[findIndex].nextYearsMonth9Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth9Total += x.countDone + x.countUndone;
                  break;
                case Month.Twelve:
                  finalList[findIndex].nextYearsMonth12 += x.countDone;
                  nextYearsMonth12 += x.countDone;
                  finalList[findIndex].nextYearsMonth12Total +=
                    x.countDone + x.countUndone;
                  nextYearsMonth12Total += x.countDone + x.countUndone;
                  break;
              }
            }

            let totalPerRow = 0;
            totalPerRow =
              finalList[findIndex].year1Month2 +
              finalList[findIndex].year1Month4 +
              finalList[findIndex].year1Month6 +
              finalList[findIndex].year1Month9 +
              finalList[findIndex].year1Month12 +
              finalList[findIndex].nextYearsMonth3 +
              finalList[findIndex].nextYearsMonth6 +
              finalList[findIndex].nextYearsMonth9 +
              finalList[findIndex].nextYearsMonth12 +
              finalList[findIndex].academic +
              finalList[findIndex].monthlyPDS;
            finalList[findIndex].totalPerRow = <>{totalPerRow}</>;

            let totalPerRowTotal = 0;
            totalPerRowTotal =
              finalList[findIndex].year1Month2Total +
              finalList[findIndex].year1Month4Total +
              finalList[findIndex].year1Month6Total +
              finalList[findIndex].year1Month9Total +
              finalList[findIndex].year1Month12Total +
              finalList[findIndex].nextYearsMonth3Total +
              finalList[findIndex].nextYearsMonth6Total +
              finalList[findIndex].nextYearsMonth9Total +
              finalList[findIndex].nextYearsMonth12Total +
              finalList[findIndex].academicTotal +
              finalList[findIndex].monthlyPDSTotal;
            finalList[findIndex].totalPerRowTotal = <>{totalPerRowTotal}</>;

            final =
              year1Month2 +
              year1Month4 +
              year1Month6 +
              year1Month9 +
              year1Month12 +
              nextYearsMonth3 +
              nextYearsMonth6 +
              nextYearsMonth9 +
              nextYearsMonth12 +
              academic +
              monthlyPDS;

            finalTotal =
              year1Month2Total +
              year1Month4Total +
              year1Month6Total +
              year1Month9Total +
              year1Month12Total +
              nextYearsMonth3Total +
              nextYearsMonth6Total +
              nextYearsMonth9Total +
              nextYearsMonth12Total +
              academicTotal +
              monthlyPDSTotal;
          }
        }
      });

      let total = {
        staffName: <strong>Total</strong>,
        year1Month2: <strong>{`${year1Month2}/${year1Month2Total}`}</strong>,
        year1Month4: <strong>{`${year1Month4}/${year1Month4Total}`}</strong>,
        year1Month6: <strong>{`${year1Month6}/${year1Month6Total}`}</strong>,
        year1Month9: <strong>{`${year1Month9}/${year1Month9Total}`}</strong>,
        year1Month12: <strong>{`${year1Month12}/${year1Month12Total}`}</strong>,
        nextYearsMonth3: (
          <strong>{`${nextYearsMonth3}/${nextYearsMonth3Total}`}</strong>
        ),
        nextYearsMonth6: (
          <strong>{`${nextYearsMonth6}/${nextYearsMonth6Total}`}</strong>
        ),
        nextYearsMonth9: (
          <strong>{`${nextYearsMonth9}/${nextYearsMonth9Total}`}</strong>
        ),
        nextYearsMonth12: (
          <strong>{`${nextYearsMonth12}/${nextYearsMonth12Total}`}</strong>
        ),
        academic: <strong>{`${academic}/${academicTotal}`}</strong>,
        monthlyPDS: <strong>{`${monthlyPDS}/${monthlyPDSTotal}`}</strong>,
        totalPerRow: <strong>{`${final}/${finalTotal}`}</strong>,
      };

      finalList.push(total);
      setFollowUpEventsStatusData(finalList);
      setLoading(false);
    });
  };

  const onSelectDateRange = (value) => {
    if (value) {
      setStartDate(moment(value[0]).startOf("M").format("MM-DD-yyyy"));
      setEndDate(moment(value[1]).endOf("M").format("MM-DD-yyyy"));
    } else {
      setStartDate([]);
      setEndDate([]);
    }
  };

  return (
    <FollowUpEventStatusListForm
      columns={columns}
      followUpEventsStatusData={followUpEventsStatusData}
      loading={loading}
      onSelectDateRange={onSelectDateRange}
      startDate={startDate}
      endDate={endDate}
    />
  );
}

export default ManageFollowUpEventStatusListPage;
